import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { UserCircle } from "heroicons-react";
import DefaultAvatar from "../../assets/img/avatar.png";
var Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 14 : _b, _c = _a.avatarUrl, avatarUrl = _c === void 0 ? DefaultAvatar : _c, className = _a.className;
    return avatarUrl ? (_jsx("img", { className: "".concat(className ? className : "", " h-").concat(size, " w-").concat(size, " rounded-full"), src: avatarUrl, alt: "Avatar" }, void 0)) : (_jsx(UserCircle, { className: "h-".concat(size, " w-").concat(size, " text-white") }, void 0));
};
export default Avatar;
